import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ToastService } from 'angular-toastify';
import { Subject, Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MainFacade } from 'src/app/pages/main.facade';
import { environment } from 'src/environments/environment.prod';

@Component({
  selector: 'app-packbuy',
  templateUrl: './packbuy.component.html',
  styleUrls: ['./packbuy.component.scss']
})
export class PackbuyComponent implements OnInit {
  quantity:number=0;
  private destroy$ = new Subject();
  public user$: Observable<any>|undefined;
  public eth$: Observable<any>|undefined;
  public packSigs$: Observable<any>|undefined;
  public loading$: Observable<any>|undefined;
  user:any='';
  eth:any=0;
  PurchaseConfirm:boolean=false;
  type:any='';
  ethPrice:any = environment.mintPrice;
  scPrice:any = environment.scPrice;
  constructor(private mainfacade:MainFacade, private sanitizer: DomSanitizer, private toastService: ToastService, private router:Router) { }
 
  ngOnInit(): void {
    
    this.createSubscriptions();
  }

  ngOnDestroy() {
    this.destroy$.next(true);
  }

  createSubscriptions(){
    this.user$ = this.mainfacade.user$;
    this.eth$ = this.mainfacade.eth$;
    this.loading$ = this.mainfacade.loading$;
    this.packSigs$ = this.mainfacade.packSigs$;
    this.user$
    .pipe(takeUntil(this.destroy$))
    .subscribe((message)=>{ 
        if(message){
          this.user = message;
        }
    });

    this.eth$
    .pipe(takeUntil(this.destroy$))
    .subscribe((message)=>{ 
        if(message){
          this.eth = message;
        }
    });


  }

  purchasePack(pack, type){
    if(pack.Claimed!==0){
      return;
    }
    this.mainfacade.setLoading(true)
    this.mainfacade.purchasePack(pack?.Sig, this.user.Id, type, pack?.Quantity );
    this.PurchaseConfirm=false;
  }

  confirm(type){
    if(this.quantity<=0){
      return;
    }
    if(type==='ETH' && this.eth<=this.quantity*0.0252){
      this.toastService.info('You do not have enough ETH to complete this action.')
      return;
    }
    this.type = type;
    this.PurchaseConfirm=true;

  }

  packSignature(type){
    if(this.quantity<=0){
      return;
    }
    this.mainfacade.setLoading(true)
    this.mainfacade.packSignature(type,this.user.Id,this.quantity)
    this.PurchaseConfirm=false;
  }


}
